import { z } from 'zod';
import type { TableEditItem } from '@/components/table/table-edit/types';
import type { PartialUndefinedOrNull } from '@/types/partial';

export const RegraFiscalServicoSchema = z.object({
    cidade: z
        .object({
            cid_cidade: z.string().nullable(),
            cid_ibge: z.string().nullable(),
            cid_pais_idpk: z.number().nullable(),
            cid_uf: z.string().nullable(),
        })
        .nullable(),
    rfs_cidade_idpk: z.number().nullable(),
    rfs_cnae: z.string().nullable(),
    rfs_codigo_nbs: z.string().nullable(),
    rfs_codigo_servico_nacional: z.string().nullable(),
    rfs_codigo_tributacao_municipio: z.string().nullable(),
    rfs_empresa_idpk: z.number(),
    rfs_ibscbs_cclasstrib: z.string().nullable(),
    rfs_ibscbs_ccredpres: z.string().nullable(),
    rfs_ibscbs_cindop: z.string().nullable(),
    rfs_ibscbs_cst: z.string().nullable(),
    rfs_ibscbs_gdif_pdifcbs: z.number(),
    rfs_ibscbs_gdif_pdifmun: z.number(),
    rfs_ibscbs_gdif_pdifuf: z.number(),
    rfs_ibscbs_gtribregular_cclasstribreg: z.string().nullable(),
    rfs_ibscbs_gtribregular_cstreg: z.string().nullable(),
    rfs_idpk: z.number(),
    rfs_iss_aliquota: z.number().nullable(),
    rfs_iss_deducao_bc: z.number().nullable(),
    rfs_iss_retido: z.string().nullable(),
    rfs_local_prestacao_servico: z.number().nullable(),
    rfs_multiempresa_uuid: z.string().nullable(),
    rfs_regra_fiscal_idpk: z.number(),
    rfs_servico_item_idpk: z.string().nullable(),
    rfs_tipo_cliente: z.number().nullable(),
    rfs_tribfed_cofins_aliquota: z.number().nullable(),
    rfs_tribfed_csll_aliquota: z.number().nullable(),
    rfs_tribfed_inss_aliquota: z.number().nullable(),
    rfs_tribfed_inss_retido: z.string().nullish(),
    rfs_tribfed_ir_aliquota: z.number().nullable(),
    rfs_tribfed_ir_retido: z.string().nullish(),
    rfs_tribfed_pis_aliquota: z.number().nullable(),
    rfs_tribfed_tpretpiscofins: z.number().nullable(),
    rfs_ultima_alteracao: z.string().nullable(),
    servico: z
        .object({
            sel_descricao: z.string(),
            sel_idpk: z.string(),
        })
        .nullable(),
});

type RegraFiscalServico = z.infer<typeof RegraFiscalServicoSchema>;

export type RegraFiscalServicoBody = PartialUndefinedOrNull<RegraFiscalServico> & TableEditItem;
